module.exports = __webpack_public_path__ + "static/media/RejectButton.52f25849.svg";